import * as z from "zod";
import { destinationSchema } from "./egressRouteShared";
import { mutator } from "./mutator";

export const createEgressRuleSchema = z.object({
  id: z.string(),
  destination: destinationSchema,
  // Omitted/null matches any port.
  port: z.number().int().min(1).max(65535).nullish(),
  action: z.enum(["allow", "deny"]),
});

export const createEgressRule = mutator({
  schema: createEgressRuleSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:egress_rules_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { id, destination, port, action } }) => {
    await tx.mutate.egressRules.insert({
      id,
      destinationType: destination.type,
      destination:
        destination.type === "cidr" ? destination.range : destination.pattern,
      port: port ?? null,
      action,
      createdAt: Date.now(),
      disabledAt: null,
      tenantId: ctx.tenantId,
    });
  },
});
